module.exports = __webpack_public_path__ + "img/Support-skill-401.74743564.png";